var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33313 10.5C5.57562 10.5 2.51562 13.02 2.51562 16.125C2.51562 16.335 2.68062 16.5 2.89062 16.5H15.7756C15.9856 16.5 16.1506 16.335 16.1506 16.125C16.1506 13.02 13.0906 10.5 9.33313 10.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 1.5C8.44801 1.5 7.63801 1.8075 6.99301 2.325C6.13051 3.0075 5.58301 4.065 5.58301 5.25C5.58301 5.955 5.77801 6.615 6.13051 7.1775C6.77551 8.265 7.96051 9 9.33301 9C10.278 9 11.1405 8.655 11.8005 8.0625C12.093 7.815 12.348 7.515 12.543 7.1775C12.888 6.615 13.083 5.955 13.083 5.25C13.083 3.18 11.403 1.5 9.33301 1.5ZM11.2755 4.845L9.27301 6.69C9.13801 6.8175 8.96551 6.8775 8.79301 6.8775C8.61301 6.8775 8.43301 6.81 8.29801 6.675L7.37551 5.745C7.09801 5.4675 7.09801 5.025 7.37551 4.7475C7.65301 4.47 8.09551 4.47 8.37301 4.7475L8.81551 5.19L10.323 3.8025C10.608 3.54 11.0505 3.555 11.313 3.84C11.5755 4.1325 11.5605 4.5825 11.2755 4.845Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTick);
export default __webpack_public_path__ + "static/media/user-tick.c222df84b5b832dfdcb76a3c56b46d4e.svg";
export { ForwardRef as ReactComponent };